.heading {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.date {
  font-size: 15px;
  color: var(--ink-2);
}

.title {
  font-size: 30px;
  line-height: 1.15;
}
